import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

export const getRowClassName = (params: any) => {
  
  return params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row";
};



// const {t}= useTranslation()
export const columns: GridColDef[] = [
  
  {
    
    field: "deviceName",
    headerName: "Device Name" ,
    width: 150,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },
  {
    field: "location",
    headerName:"Location",
    width: 200,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },
  {
    field: "groupName",
    headerName: "Group Name",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    // renderCell: (params) => (params.value === true ? "Yes" : "No"),
  },
  {
    field: "status",
    headerName: "Status",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    renderCell: (params) => {
      let color;
      switch (params.value) {
        case "Clean":
          color = "green";
          break;
        case "Critical":
          color = "red";
          break;
        case "moderate":
          color = "orange";
          break;
        default:
          color = "inherit";
      }

      return (
        <span style={{ color }}>
          {params.value}
        </span>
      );
    },
  },
  {
    field: "level",
    headerName: "Fill Level(%)",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },
  {
    field: "lastCollectedDate",
    headerName: "Last Collected",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },

  {
    field: "nextCollectionDate",
    headerName: "Next Collection",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },

  {
    field: "actionTaken",
    headerName: "Action Taken",
    width: 0.55,
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },

];

